<template>
    <div class="offer-list-empty">
      <img src="/img/anylvl-logo.svg" class="empty-icon">
      <span class="h4">{{ message }}</span>
      <p>{{ subMessage }}</p>
      <b-button
        v-if="buttonLink && buttonLink != ''"
        class="btn btn-success"
        @click="goToButtonLink">
        {{ buttonMessage }}
      </b-button>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  export default {
    props: {
      message: {
        type: String,
        default: "В этой категории пока нет предложений",
      },
      subMessage: {
        type: String,
        default: "В этой категории пока нет предложений",
      },
      buttonLink: {
        type: String,
        default: null,
      },
      buttonMessage: {
        type: String,
        default: null,
      },
      checkAuth: {
        type: Boolean,
        default: false,
      },
      checkPhone: {
        type: Boolean,
        default: false,
      },
      checkEmail: {
        type: Boolean,
        default: false,
      },
    },
    computed: mapState({
      user: (state) => state.auth.user,
    }),
    methods: {
      goToButtonLink() {
        if (this.checkAuth) {
          if (!this.user) {
            this.$root.$emit("bv::show::modal", "modalLoginSocial");
            return;
          }
        }
  
        if (this.checkEmail) {
          if (!this.user.is_active) {
            this.$bvModal.show("modalRegistrationCode");
            return;
          }
        }
  
        if (this.checkPhone) {
          if (!this.user.is_phone_verified) {
            this.$bvModal.show("modalConfirmPhone");
            return;
          }
        }
  
        // Проверяем, является ли ссылка внешней
        if (this.buttonLink.startsWith('http://') || this.buttonLink.startsWith('https://')) {
          window.location.href = this.buttonLink;
        } else {
          this.$router.push({
            path: this.buttonLink,
          });
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .offer-list-empty {
    width: 100%;
    background-color: #EFF1F4;
    padding-top: 52px;
    padding-bottom: 52px;
    text-align: center;
    color: #6e7279;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .h4 {
      margin-top: 30px;
      color: $body-color;
    }
  }
  .offers-empty-link {
    display: inline-block;
    padding-left: 35px;
    &:before {
      left: 12px;
    }
  }
  .empty-icon {
    display: inline-block;
    width: 128px;
  }
  </style>